import { createSlice } from '@reduxjs/toolkit';

export interface DialogState {
  isShowDialog: boolean;
  title: string;
  content: string;
};
const initialState: DialogState = {
  isShowDialog: false,
  title: "Batch Scan Solution Available",
  content: "Enhance performance with our Batch Scanning Solution, designed to consistently achieve close to 100% read rate across 100+ barcodes."
}

const dialogStatesSlice = createSlice({
  name: 'dialog',
  initialState,
  reducers: {
    updateDialogState: (state, action: {
      payload: { value: boolean | string, stateName: keyof DialogState };
      type: string;
    }) => {
      const { stateName, value } = action.payload;
      (state as any)[stateName] = value;
      return state;
    }
  },
});

export const { updateDialogState } = dialogStatesSlice.actions;

export default dialogStatesSlice.reducer;